import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Redirect from '../../../common/components/Redirect';
import withQuery from '../../../common/components/withQuery';
import CurrentUserActions from '../../../redux-modules/current-user';

class Logout extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
    }),
  };
  componentWillMount() {
    this.props.actions.user.logout();
    //ga('set', 'userId', null);
  }

  render() {
    const { query } = this.props.location;
    const defaultUrl = __DEV__ ? '/auth/login' : '/redirect/logout';
    const redirectUrl = query && query.returnUrl ? query.returnUrl : defaultUrl;
    return <Redirect external to={redirectUrl} />;
  }
}
export default withQuery(
  connect(null, dispatch => ({
    actions: { user: bindActionCreators(CurrentUserActions, dispatch) },
  }))(Logout)
);



// WEBPACK FOOTER //
// ./src/App/auth/Views/Logout.js